import styled from 'styled-components';

export const Loading = styled.div`
  align-items: center;
  text-align: center;
  font-weight: bold;
  min-width: 100%;
`;
